export const LicenseSummaryMockData = 'QOEJ-SRKI-TNDJ-TDOO-DSRK-JOKV-MTCM-PTVO';
